<template>
<div class="flex flex-row h-full">
  <div class="flex-1 flex flex-col">
    <div class="bg-white rounded-lg">
      <div class="pt-4 text-[#2F2F2F] px-4 font-semibold text-base">发起签署</div>
      <div class="flex flex-row flex-nowrap my-[21px] mx-[32px]">
        <!-- <el-button type="primary"  class="flex-none w-[180px] h-[70px]">上传文件<br/>
        <div class="pt-[12px] text-base">发起签署</div></el-button>
        <el-button type="primary"  class="flex-none w-[180px] h-[70px]">签署列表<br/>
        <div class="pt-[12px] text-base">签署任务列表</div></el-button> -->
        <el-image src="/images/upload_files.png" class="w-[191px] h-[61px] cursor-pointer" @click="signStart()"></el-image>
        <el-image src="/images/contract_template.png" class="w-[191px] h-[61px] cursor-pointer ml-[21px]"></el-image>
      </div>
    </div>
    <div class="flex flex-col mt-[22px] bg-white rounded-lg">
      <div class="pt-4 text-[#2F2F2F] px-4 font-semibold text-base">合同管理</div>
        <el-tabs v-model="contractActive" class="px-4 py-[10px] min-h-[200px] bg-white rounded-lg" @tab-click="handleClickContract">

          <el-tab-pane label="我收到的" name="contract-received" class="h-full text-center">
            <div class="flex flex-col" v-if="listToContractReceived.length > 0">
              <div v-for="(item, index) in listToContractReceived" :key="index" class="tabsHover flex-1 flex justify-between items-center flex-row px-[10px] py-[5px]">
                <div class="w-1/6 items-center leading-[60px] text-sm text-[#2F2F2F] text-left whitespace-nowrap text-ellipsis overflow-hidden">{{ item.signFlowTitle }}</div>
                
                <div class="w-1/6 justify-start items-center pb-0.5 text-[#2F2F2F] text-sm text-left whitespace-nowrap text-ellipsis overflow-hidden">发起方：{{ item.initiatorName }}</div>

                <div class="w-1/3 flex justify-start items-center pb-0.5 text-[#2F2F2F] text-sm text-left whitespace-nowrap text-ellipsis overflow-hidden">参与方：
                  <div class="flex justify-start items-center flex-wrap">
                    <div class="flex justify-start items-center ml-[12px] my-[5px]" v-for="(items, index) in item.signers" :key="index">
                        <div v-if="items.psnName != ''">
                          {{ items.psnName }}
                        </div>
                        <div v-else>
                          {{ items.accountMobile }}
                        </div>
                        <div class="text-xs px-2.5 py-1.5 ml-[10px]"
                          :style="{color: colorStatusPsn(items.signStatus),
                          backgroundColor: backgroundColorStatusPsn(items.signStatus)}"
                          v-if="item.signFlowStatus != 2">
                          {{items.signStatus | filterStatusPsn}}
                        </div>
                      </div>
                  </div>
                </div>
                
                <div class="w-1/6 items-center leading-[60px] text-sm text-[#2F2F2F] text-left whitespace-nowrap text-ellipsis overflow-hidden">{{ dateFormat(item.signFlowStartTime) }}</div>

                <div class="flex-1 text-right whitespace-nowrap">
                  <el-button type="info" v-if="item.signFlowStatus == 0">草稿</el-button>
                  <el-button type="primary" v-else-if="item.signFlowStatus == 1" @click="sign(item.signFlowId)">签署</el-button>
                  <el-button type="success" v-else-if="item.signFlowStatus == 2">已完成</el-button>
                  <el-button type="danger" v-else-if="item.signFlowStatus == 3">已撤销</el-button>
                  <el-button type="info" v-else-if="item.signFlowStatus == 5">已过期</el-button>
                  <el-button type="danger" v-else-if="item.signFlowStatus == 7">已拒签</el-button>
                  <el-button type="danger" plain @click="detail(item.signFlowId)">查看</el-button>
                </div>
              </div>
            </div>
            <div class="flex flex-col" v-else>
              <el-image src="/images/no_data.png" class="w-[99px] h-[53px] m-auto"></el-image>
              <div class="text-[#B8B8B8] text-sm mt-[11px]">暂无更多数据~</div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="我发起的" name="contract-initiated" class="h-full text-center">
            <div class="flex flex-col" v-if="listToContractInitiated.length > 0">
              <div v-for="(item, index) in listToContractInitiated" :key="index" class="tabsHover flex-1 flex justify-between items-center flex-row px-[10px] py-[5px]">
                <div class="w-1/6 items-center leading-[60px] text-sm text-[#2F2F2F] text-left  whitespace-nowrap text-ellipsis overflow-hidden">{{ item.signFlowTitle }}</div>
                
                <div class="w-1/6 justify-start items-center pb-0.5 text-[#2F2F2F] text-sm text-left  whitespace-nowrap text-ellipsis overflow-hidden">发起方：{{ item.initiatorName }}</div>

                <div class="w-1/3 flex justify-start items-center pb-0.5 text-[#2F2F2F] text-sm text-left  whitespace-nowrap text-ellipsis overflow-hidden">参与方：
                  <div class="flex justify-start items-center flex-wrap">
                    <div class="flex justify-start items-center ml-[12px]" v-for="(items, index) in item.signers" :key="index">
                      <div v-if="items.psnName != ''">
                          {{ items.psnName }}
                        </div>
                        <div v-else>
                          {{ items.accountMobile }}
                        </div>
                        <div class="text-xs px-2.5 py-1.5 ml-[10px]"
                          :style="{color: colorStatusPsn(items.signStatus),
                          backgroundColor: backgroundColorStatusPsn(items.signStatus)}"
                          v-if="item.signFlowStatus != 2">
                          {{items.signStatus | filterStatusPsn}}
                        </div>
                      </div>
                  </div>
                </div>
                
                <div class="w-1/6 items-center leading-[60px] text-sm text-[#2F2F2F] text-left  whitespace-nowrap text-ellipsis overflow-hidden">{{ dateFormat(item.signFlowStartTime) }}</div>

                <div class="flex-1 text-right  whitespace-nowrap">
                  <el-button type="info" v-if="item.signFlowStatus == 0">草稿</el-button>
                  <el-button type="primary" v-else-if="item.signFlowStatus == 1" @click="sign(item.signFlowId)">签署</el-button>
                  <el-button type="success" v-else-if="item.signFlowStatus == 2">已完成</el-button>
                  <el-button type="danger" v-else-if="item.signFlowStatus == 3">已撤销</el-button>
                  <el-button type="info" v-else-if="item.signFlowStatus == 5">已过期</el-button>
                  <el-button type="danger" v-else-if="item.signFlowStatus == 7">已拒签</el-button>
                  <el-button type="danger" plain @click="detail(item.signFlowId)">查看</el-button>
                </div>
              </div>
            </div>
            <div class="flex flex-col" v-else>
              <el-image src="/images/no_data.png" class="w-[99px] h-[53px] m-auto"></el-image>
              <div class="text-[#B8B8B8] text-sm mt-[11px]">暂无更多数据~</div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="待我操作" name="contract-operated" class="h-full text-center">
            <div class="flex flex-col" v-if="listToContractOperated.length > 0">
              <div v-for="(item, index) in listToContractOperated" :key="index" class="tabsHover flex-1 flex justify-between items-center flex-row px-[10px] py-[5px]">
                <div class="w-1/6 items-center leading-[60px] text-sm text-[#2F2F2F] text-left whitespace-nowrap text-ellipsis overflow-hidden">{{ item.signFlowTitle }}</div>
                
                <div class="w-1/6 justify-start items-center pb-0.5 text-[#2F2F2F] text-sm text-left whitespace-nowrap text-ellipsis overflow-hidden">发起方：{{ item.initiatorName }}</div>

                <div class="w-1/3 flex justify-start items-center pb-0.5 text-[#2F2F2F] text-sm text-left whitespace-nowrap text-ellipsis overflow-hidden">参与方：
                  <div class="flex justify-start items-center flex-wrap">
                    <div class="flex justify-start items-center ml-[12px]" v-for="(items, index) in item.signers" :key="index">
                      <div v-if="items.psnName != ''">
                          {{ items.psnName }}
                        </div>
                        <div v-else>
                          {{ items.accountMobile }}
                        </div>
                        <div class="text-xs px-2.5 py-1.5 ml-[10px]"
                          :style="{color: colorStatusPsn(items.signStatus),
                          backgroundColor: backgroundColorStatusPsn(items.signStatus)}"
                          v-if="item.signFlowStatus != 2">
                          {{items.signStatus | filterStatusPsn}}
                        </div>
                      </div>
                  </div>
                </div>
                
                <div class="w-1/6 items-center leading-[60px] text-sm text-[#2F2F2F] text-left whitespace-nowrap text-ellipsis overflow-hidden">{{ dateFormat(item.signFlowStartTime) }}</div>
                
                
                <div class="flex-1 text-right whitespace-nowrap">
                  <el-button type="info" v-if="item.signFlowStatus == 0">草稿</el-button>
                  <el-button type="primary" v-else-if="item.signFlowStatus == 1" @click="sign(item.signFlowId)">签署</el-button>
                  <el-button type="success" v-else-if="item.signFlowStatus == 2">已完成</el-button>
                  <el-button type="danger" v-else-if="item.signFlowStatus == 3">已撤销</el-button>
                  <el-button type="info" v-else-if="item.signFlowStatus == 5">已过期</el-button>
                  <el-button type="danger" v-else-if="item.signFlowStatus == 7">已拒签</el-button>
                  <el-button type="danger" plain @click="detail(item.signFlowId)">查看</el-button>
                </div>
              </div>
            </div>
            <div class="flex flex-col" v-else>
              <el-image src="/images/no_data.png" class="w-[99px] h-[53px] m-auto"></el-image>
              <div class="text-[#B8B8B8] text-sm mt-[11px]">暂无更多数据~</div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="已完成" name="contract-completed" class="h-full text-center">
            <div class="flex flex-col" v-if="listToContractCompleted.length > 0">
             <div v-for="(item, index) in listToContractCompleted" :key="index" class="tabsHover flex-1 flex justify-between items-center flex-row px-[10px] py-[5px]">
                <div class="w-1/6 items-center leading-[60px] text-sm text-[#2F2F2F] text-left whitespace-nowrap text-ellipsis overflow-hidden">{{ item.signFlowTitle }}</div>
                
                <div class="w-1/6 justify-start items-center pb-0.5 text-[#2F2F2F] text-sm text-left whitespace-nowrap text-ellipsis overflow-hidden">发起方：{{ item.initiatorName }}</div>

                <div class="w-1/3 flex justify-start items-center pb-0.5 text-[#2F2F2F] text-sm text-left whitespace-nowrap text-ellipsis overflow-hidden">参与方：
                  <div class="flex justify-start items-center flex-wrap">
                    <div class="flex justify-start items-center ml-[12px]" v-for="(items, index) in item.signers" :key="index">
                      <div v-if="items.psnName != ''">
                          {{ items.psnName }}
                        </div>
                        <div v-else>
                          {{ items.accountMobile }}
                        </div>
                        <div class="text-xs px-2.5 py-1.5 ml-[10px]"
                          :style="{color: colorStatusPsn(items.signStatus),
                          backgroundColor: backgroundColorStatusPsn(items.signStatus)}"
                          v-if="item.signFlowStatus != 2">
                          {{items.signStatus | filterStatusPsn}}
                        </div>
                      </div>
                  </div>
                </div>
                
                <div class="w-1/6 items-center leading-[60px] text-sm text-[#2F2F2F] text-left whitespace-nowrap text-ellipsis overflow-hidden">{{ dateFormat(item.signFlowStartTime) }}</div>

                <div class="flex-1 text-right whitespace-nowrap">
                  <el-button type="info" v-if="item.signFlowStatus == 0">草稿</el-button>
                  <el-button type="primary" v-else-if="item.signFlowStatus == 1" @click="sign(item.signFlowId)">签署</el-button>
                  <el-button type="success" v-else-if="item.signFlowStatus == 2">已完成</el-button>
                  <el-button type="danger" v-else-if="item.signFlowStatus == 3">已撤销</el-button>
                  <el-button type="info" v-else-if="item.signFlowStatus == 5">已过期</el-button>
                  <el-button type="danger" v-else-if="item.signFlowStatus == 7">已拒签</el-button>
                  <el-button type="danger" plain @click="detail(item.signFlowId)">查看</el-button>
                </div>
              </div>
            </div>
            <div class="flex flex-col" v-else>
              <el-image src="/images/no_data.png" class="w-[99px] h-[53px] m-auto"></el-image>
              <div class="text-[#B8B8B8] text-sm mt-[11px]">暂无更多数据~</div>
            </div>
          </el-tab-pane>
        </el-tabs>
        <el-pagination
          class="text-center"
          layout="prev, pager, next"
          @current-change="handleCurrentChangeContract"
          :total="totalContract">
        </el-pagination>
    </div>


    <div class="flex-1 flex flex-col mt-[22px] bg-white rounded-lg">
      <div class="pt-4 text-[#2F2F2F] px-4 font-semibold text-base">审批管理</div>
        <el-tabs v-model="approvalActive" class="px-4 py-[10px] min-h-[200px] bg-white rounded-lg" @tab-click="handleClickApproval">
        <el-tab-pane label="我收到的" name="approval-received" class="h-full text-center">
          <div class="flex flex-col" v-if="listToApprovalReceived.length > 0">
              <div v-for="(item, index) in listToApprovalReceived" :key="index" class="flex-1 flex flex-row mx-[10px] my-[5px]">
              </div>
            </div>
            <div class="flex flex-col" v-else>
              <el-image src="/images/no_data.png" class="w-[99px] h-[53px] m-auto"></el-image>
              <div class="text-[#B8B8B8] text-sm mt-[11px]">暂无更多数据~</div>
            </div>
        </el-tab-pane>
        <el-tab-pane label="我发起的" name="approval-initiated" class="h-full text-center">
          <div class="flex flex-col" v-if="listToApprovalInitiated.length > 0">
              <div v-for="(item, index) in listToApprovalInitiated" :key="index" class="flex-1 flex flex-row mx-[10px] my-[5px]">
              </div>
            </div>
            <div class="flex flex-col" v-else>
              <el-image src="/images/no_data.png" class="w-[99px] h-[53px] m-auto"></el-image>
              <div class="text-[#B8B8B8] text-sm mt-[11px]">暂无更多数据~</div>
            </div>
        </el-tab-pane>
        <el-tab-pane label="待我审批" name="approval-operated" class="h-full text-center">
          <div class="flex flex-col" v-if="listToApprovalOperated.length > 0">
              <div v-for="(item, index) in listToApprovalOperated" :key="index" class="flex-1 flex flex-row mx-[10px] my-[5px]">
              </div>
            </div>
            <div class="flex flex-col" v-else>
              <el-image src="/images/no_data.png" class="w-[99px] h-[53px] m-auto"></el-image>
              <div class="text-[#B8B8B8] text-sm mt-[11px]">暂无更多数据~</div>
            </div>
        </el-tab-pane>
        <el-tab-pane label="我已审批" name="approval-completed" class="h-full text-center">
          <div class="flex flex-col" v-if="listToApprovalCompleted.length > 0">
              <div v-for="(item, index) in listToApprovalCompleted" :key="index" class="flex-1 flex flex-row mx-[10px] my-[5px]">
              </div>
            </div>
            <div class="flex flex-col" v-else>
              <el-image src="/images/no_data.png" class="w-[99px] h-[53px] m-auto"></el-image>
              <div class="text-[#B8B8B8] text-sm mt-[11px]">暂无更多数据~</div>
            </div>
        </el-tab-pane>
      </el-tabs>
      <el-pagination
          class="text-center"
          layout="prev, pager, next"
          @current-change="handleCurrentChangeApproval"
          :total="totalApproval">
        </el-pagination>
    </div>
  </div>
  <div class="flex flex-col ml-[20px] w-[380px]">
    <div class="bg-white rounded-lg">
      <div class="flex flex-row items-center justify-cente mx-[20px] my-[15px]">
        <el-avatar class= "mr-[10px]" size="medium" src="/images/bst-small.png"></el-avatar>
        <div class="flex-1 flex flex-col text-sm">
          <div class="font-[600] mb-[5px]"><span class="whitespace-nowrap overflow-hidden overflow-ellipsis">欢迎您，{{profile.userName}}</span></div>
          <div><span class="whitespace-nowrap overflow-hidden overflow-ellipsis">{{profile.orgName}}</span></div>
        </div>
      </div>
      <div class="mx-[20px] my-[10px] border-t border-solid"></div>
      <div class="text-sm py-[5px] px-[20px] text-[#aaa]">
        <!-- <div class="py-[5px]">企业管理员：<span class="text-black">XXX</span></div> -->
        <div class="py-[5px]">可签署份数：<span class="text-black">{{remainingNum}} 份</span></div>
      </div>
    </div>
    <div class="flex-1 mt-[20px] bg-white rounded-lg">
      <div class="px-[20px]">
        <div class="pt-4 text-[#2F2F2F] font-semibold text-base">常见问题</div>
        <div class="my-[10px] border-t border-solid"></div>
        <ul class="text-[#2F2F2F]">
          <li class="text-base py-1.5"><a href="#">1. 如何进行个人实名认证？</a></li>
          <li class="text-base py-1.5"><a href="#">2. 如何进行企业实名认证？</a></li>
          <li class="text-base py-1.5"><a href="#">3. 电子合同的法律依据是什么？</a></li>
          <li class="text-base py-1.5"><a href="#">4. 找不到合同怎么办？</a></li>
          <li class="text-base py-1.5"><a href="#">5. 管理员离职了如何转授管理员？</a></li>
          <li class="text-base py-1.5"><a href="#">6. 如何创建企业印章?</a></li>
          <li class="text-base py-1.5"><a href="#">7. 如何直接发起签署合同？</a></li>
          <li class="text-base py-1.5"><a href="#">8. 如何进入企业控制台？</a></li>
          <li class="text-base py-1.5"><a href="#">9. 已签署的合同如何解约/作废？</a></li>
        </ul>
      </div>
    </div>
  </div>
   <el-dialog title="签署任务" :visible.sync="dialogVisible" width="380px" 
    >
    <el-form :model="editItem" label-width="80px"  
      v-loading="loading"
      element-loading-text="提交数据中，请稍候"
      element-loading-spinner="el-icon-loading">
      <el-form-item label="任务名称">
        <el-input v-model="editItem.name" maxlength="50" ref="taskName"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer" style="width:100%">
      <el-button @click="signCancel()">取 消</el-button>
      <el-button type="primary" @click="signNext()">确 定</el-button>
    </span>

  </el-dialog>
</div>
</template>

<script>
import { fetchSignFlowInitiate, fetchSignUrl, 
fetchContractList, fetchApprovalList,
fetchDetailUrl, fetchUserRemainingNum } from '../api/api.js';

export default {
  name: 'FlowPage',
  props: {
    profile:Object,
  },
  data(){
    return {
      contractActive: "contract-received",
      listToContractReceived: [], // 我收到的
      listToContractInitiated: [], // 我发起的
      listToContractOperated: [], // 待我操作
      listToContractCompleted: [], // 已完成

      approvalActive: "approval-received",
      listToApprovalReceived: [], // 我收到的
      listToApprovalInitiated: [],// 我发起的
      listToApprovalOperated: [], // 待我审批
      listToApprovalCompleted: [],// 我已审批

      
      editItem:{
        name: "",
      },
      dialogVisible:false,
      loading:false,

      pageContract: 1,
      limitContract: 10,
      totalContract: 0,

      pageApproval: 1,
      limitApproval: 10,
      totalApproval: 0,

      contractType: "2", // 合同类型
      approvalType: "2", // 审批类型
      flowTitle: "",
      status: "",

      remainingNum: 0
    }
  },
  mounted() {
    this.contractList();
    this.approvalList();
    this.getUserRemainingNum();
  },
  methods: {
    async getUserRemainingNum() {
      var params = {
        "orgId": localStorage.getItem("RemainingNumId")
      }
      try {
        let result = await fetchUserRemainingNum(params);

        if (result.data.code == 0) {
          this.remainingNum = result.data.data.amount;
        }
      }catch(err){
        console.log(err);
      }
    },
    signStart() {
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.taskName.focus();
      });
    },
    signCancel() {
      this.dialogVisible = false
      this.editItem.name = ""
    },
    async signNext() {
      this.editItem.name = this.editItem.name.trim()
      if (this.editItem.name == "") {
        this.$message.error("任务名称不能为空")
        return
      }
      
      this.loading = true
      try {
        this.loading = true
        var params = {
					"initiatePageConfig": {
						"customBizNum": "",
						"initiateButtons": "",
						"redirectUrl": "https://econtract.top/home"
					},
					"signFlowConfig": {
						"authConfig": {
							"audioVideoTemplateId": "",
							"orgAvailableAuthModes": [],
							"psnAvailableAuthModes": [],
							"willingnessAuthModes": []
						},
						"autoFinish": false,
						"autoStart": false,
						"chargeConfig": {
							"barrierCode": "",
							"chargeMode": 0,
							"orderType": ""
						},
						"noticeConfig": {
							"noticeTypes": ""
						},
						"notifyUrl": "",
						"redirectConfig": {
							"redirectDelayTime": 0,
							"redirectUrl": "https://econtract.top/home"
						},
						"signConfig": {
							"availableSignClientTypes": "",
							"showBatchDropSealButton": false
						},
						"signFlowExpireTime": 0,
						"signFlowTitle": this.editItem.name
					}
				}
        const response = await fetchSignFlowInitiate(params)
        if(response.data.code !== 0) {
          this.loading = false
          console.error('signFlowInitiate:', response.data.message);
          return;
        }
        this.dialogVisible = false
        this.editItem.name = ""
        window.open(response.data.data.signFlowInitiateLongUrl)
      } catch (error) {
        console.error('signFlowInitiate:', error);
      }
      this.loading = false
    },
    async contractList() {
      if(this.contractActive == "contract-received") {
        this.contractType = "2";
      }else if(this.contractActive == "contract-initiated") {
        this.contractType = "1";
      }else if(this.contractActive == "contract-operated") {
        this.contractType = "3";
      }else if(this.contractActive == "contract-completed") {
        this.contractType = "4";
      }

      const raw = {
          "page": this.pageContract,
					"limit": this.limitContract,
					"queryType": this.contractType,
					"flowTitle": this.flowTitle,
					"status": this.status
      };
      try {
        let result = await fetchContractList(raw);
        // console.log(result,"合同管理")

          if (result.data.code !== 0) {
            console.error("错误信息：", result.data.data.message);
            this.$message.error("无法管理合同，请稍候再试");
            return;
          }
          else if (!result.data.data.data) {
            this.$message.error("无法管理合同，请稍候再试");
            return;
          }else {
            if(this.contractActive == "contract-received") {
              this.listToContractReceived = [];
              this.listToContractReceived = result.data.data.data;
            }else if(this.contractActive == "contract-initiated") {
              this.listToContractInitiated = [];
              this.listToContractInitiated = result.data.data.data;
            }else if(this.contractActive == "contract-operated") {
              this.listToContractOperated = [];
              this.listToContractOperated = result.data.data.data;
            }else if(this.contractActive == "contract-completed") {
              this.listToContractCompleted = [];
              this.listToContractCompleted = result.data.data.data;
            }

            this.totalContract = result.data.data.total;
          }
      } catch (e){
        console.error("错误信息：", e);
        this.$message.error("无法登录系统");
      }
    },
    async approvalList() {
      if(this.approvalActive == "approval-received") {
        this.approvalType = "2";
      }else if(this.approvalActive == "approval-initiated") {
        this.approvalType = "1";
      }else if(this.approvalActive == "approval-operated") {
        this.approvalType = "3";
      }else if(this.approvalActive == "approval-completed") {
        this.approvalType = "4";
      }

      const raw = {
          "page": this.pageApproval,
					"limit": this.limitApproval,
					"queryType": this.approvalType,
					"flowTitle": this.flowTitle,
					"status": this.status
      };
      try {
        let result = await fetchApprovalList(raw);
        // console.log(result,"审批管理")

          if (result.data.code !== 0) {
            console.error("错误信息：", result.data.data.message);
            this.$message.error("无法审批合同，请稍候再试");
            return;
          }
          else if (!result.data.data.data) {
            this.$message.error("无法审批合同，请稍候再试");
            return;
          }else {
            if(this.approvalActive == "approval-received") {
              this.listToApprovalReceived = [];
              this.listToApprovalReceived = result.data.data.data;
            }else if(this.approvalActive == "approval-initiated") {
              this.listToApprovalInitiated = [];
              this.listToApprovalInitiated = result.data.data.data;
            }else if(this.approvalActive == "approval-operated") {
              this.listToApprovalOperated = [];
              this.listToApprovalOperated = result.data.data.data;
            }else if(this.approvalActive == "approval-completed") {
              this.listToApprovalCompleted = [];
              this.listToApprovalCompleted = result.data.data.data;
            }

            this.totalApproval = result.data.data.total;
          }
      } catch (e){
        console.error("错误信息：", e);
        this.$message.error("无法登录系统");
      }
    },
    dateFormat(time) {
				let date = new Date(time);
				let year = date.getFullYear();
				// 在日期格式中，月份是从0开始的，因此要加0，使用三元表达式在小于10的前面加0，以达到格式统一  如 09:11:05
				let month = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;
				let day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
				let hours = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
				let minutes = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
				let seconds = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
				// 拼接
				return year + "-" + month + "-" + day + " " + hours + ":" + minutes + ":" + seconds;
				// return year + "-" + month + "-" + day;
			},
      colorStatusPsn(value) {
				const statusColorMap = ["#5233FF", "#FF4D4D", "#32D56E", "#5233FF", "#FF4D4D"];
			
				return statusColorMap[value] || "#4D4D4D";
			},
      backgroundColorStatusPsn(value) {
				const statusColorMap = ["#F2F0FF", "#FFFAFA", "#F0FFF5", "#F2F0FF", "#FFFAFA"];
			
				return statusColorMap[value] || "#F4F4F4";
			},
      handleCurrentChangeContract(val) {
        this.pageContract = val;
        this.contractList();
      },
      handleCurrentChangeApproval(val) {
        this.pageApproval = val;
        this.approvalList();
      },
      handleClickContract() {
        this.pageContract = 1;
        this.contractList();
      },
      handleClickApproval() {
        this.pageApproval = 1;
        this.approvalList();
      },
      detail(signFlowId) {
        var params = {
					"appScheme": "",
					"clientType": "ALL",
					"needLogin": false,
					"operator": {
						"psnAccount": "",
						"psnId": ""
					},
					"organization": {
						"orgId": "",
						"orgName": ""
					},
					"redirectConfig": {
						"redirectDelayTime": 0,
						"redirectUrl": "https://econtract.top/home"
					},
					"urlType": 1
				};
        fetchDetailUrl(signFlowId, params).then(result => {
          try{
            window.open(result.data.data.url)
          }catch(e) {
            console.log(e);
          }
        })
      },
    sign(signFlowId) {
      var params = {
					"appScheme": "",
					"clientType": "ALL",
					"needLogin": false,
					"operator": {
						"psnAccount": "",
						"psnId": ""
					},
					"organization": {
						"orgId": "",
						"orgName": ""
					},
					"redirectConfig": {
						"redirectDelayTime": 0,
						"redirectUrl": "https://econtract.top/home"
					},
					"urlType": 2
				};
        fetchSignUrl(signFlowId, params).then(result => {
          try{
            window.open(result.data.data.url)
          }catch(e) {
            console.log(e);
          }
        })
    }
  },
  filters: {
    filterStatusPsn(val) {
				if (val == 0) {
					return "等待签署"
				} else if (val == 1) {
					return "未签署"
				} else if (val == 2) {
					return "已签署"
				} else if (val == 3) {
					return "等待审批"
				} else if (val == 4) {
					return "已拒签"
				} 
			},
  }
}
</script>


<style scoped>
.tabsHover:hover {
  background: #F3F5F7;
}
</style>